import { StringDevUIField } from "./StringDevUIField";

export class StringDevFieldSelect extends StringDevUIField<string> {
  private options: ReadonlyArray<{ value: string; label: string }>;
  private select: HTMLSelectElement | null = null;
  private display: HTMLSpanElement | null = null;

  constructor(
    key: string,
    label: string,
    defaultValue: string,
    onChange: (key: string, value: string) => void,
    options: ReadonlyArray<{ value: string; label: string }>,
  ) {
    super(key, label, defaultValue, onChange);
    this.options = options;
  }

  build(): HTMLElement {
    const row = this.createRow();
    row.appendChild(this.createLabel());
    row.appendChild(this.createControl());
    this.root = row;
    return row;
  }

  setValue(value: string): void {
    this.value = value;
    if (this.select) this.select.value = value;
    if (this.display) this.display.textContent = this.getOptionLabel(value);
  }

  private createControl(): HTMLDivElement {
    const shell = document.createElement("div");
    shell.setAttribute("data-string-dev-select-shell", "");

    const valueWrap = document.createElement("div");
    valueWrap.setAttribute("data-string-dev-select-value-wrap", "");

    const display = document.createElement("span");
    display.setAttribute("data-string-dev-select-display", "");
    display.textContent = this.getOptionLabel(this.value);

    const select = document.createElement("select");
    select.setAttribute("data-string-dev-field-select", "");

    for (const opt of this.options) {
      const option = document.createElement("option");
      option.value = opt.value;
      option.textContent = opt.label;
      if (opt.value === this.value) option.selected = true;
      select.appendChild(option);
    }

    select.addEventListener("change", () => {
      display.textContent = this.getOptionLabel(select.value);
      this.emit(select.value);
    });

    const indicator = document.createElement("div");
    indicator.setAttribute("data-string-dev-select-indicator", "");
    indicator.innerHTML =
      `<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 5.5 8 10.5l5-5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

    this.select = select;
    this.display = display;
    valueWrap.appendChild(display);
    shell.appendChild(valueWrap);
    shell.appendChild(indicator);
    shell.appendChild(select);
    return shell;
  }

  private getOptionLabel(value: string): string {
    return this.options.find((option) => option.value === value)?.label ?? value;
  }
}
